<template>
  <div class="page">
    <div class="page-container">
      <!--        网站首页-->
      <div class="page-tab">
        <img src="../assets/image/page/icon.png"/>
        <div @click="goHome()" class="page-tab-text">网站首页 >> </div>
        <span>新闻动态</span>
      </div>
      <!--        文字标题部分-->
      <div class="page-content">
        <div class="page-title">极欧科技携手中国银行湖北分行打造“爱的留言板” ——最美逆行者，我想对你说！</div>
        <div class="page-time">
          <div class="page-line" style="margin-right: 20px"></div>
          2020年10月30日
          <span>来源：北国网</span>
          <div class="page-line" style="margin-left: 20px"></div>
        </div>
      </div>
      <!--        文字内容部分-->
      <div class="page-product">
        <div class="page-feed">
          <span>提要: </span>
          「2020是我们在一起风风雨雨走过的第16个年头，不奢求荣华富贵，只祈求你平安健康！你是家里的天，在前线，一定要注意保护好自己，我和二宝都期待能够早日春暖花开，合家团圆！」
        </div>
        <!--          第一部分-->
        <div class="page-one">
          <div class="page-text">
            2019年末，一场突如其来的疫情，让曾经触手可及的日常，成为了最难以实现的奢望。无数家庭生离死别、无数英雄万里驰援，但更多的，是无数平凡的人们，以自己的方式，与疫情战斗。
          </div>
          <div class="page-text">
            或许是放下儿女情长，一同奋战的医生夫妻；或许是害怕父母担心，悄悄报名去前线的年轻姑娘；或许是加班加点，建造雷神山火神山的建筑工人；或许是维护社区稳定，排查疫情的社区工作者；或许是主动援助，哪里需要跑哪里的志愿者；或许是响应号召宅家，不给病毒可趁之机的普通人……
          </div>
          <div class="page-text">
            在这一关键时期，在2020年学雷锋日前夕，身处疫区中心的中国银行湖北分行，用行动践行责任担当，积极支持全国人民抗击疫情，为了每一位奋战在“疫”线上的最美逆行者，化身为爱的信使，以“爱的留言板”之名，将前线舍生忘死的抗疫英雄与后方无数默默关怀守候的人们连结了起来。
          </div>
          <div class="page-img">
            <img src="../assets/image/page/page1.jpg"/>
          </div>
        </div>
        <!--          第二部分-->
        <div class="page-one">

          <div class="page-text">
            活动孵化成型仅仅用了3天时间，从3月2日极欧科技团队接受中国银行湖北分行活动需求后，立刻进行视频会议讨论商研，到3月3日提出活动策划，3月4日完成系统开发，3月5日活动上线；至3月7日中午12点，短短两天时间，活动收到了近5万条“爱的留言”。
          </div>
          <div class="page-text">
            在这数万条留言之中，有父母对孩子的叮嘱：
          </div>
          <div class="page-text">
            「聪儿：从去年9月至今，作为公安的一员，一直奋战在军运会和疫情第一线，无暇回家。妈妈希望你平平安安，注意身体！你是妈妈永远的牵挂与骄傲。」
          </div>
          <div class="page-text">
            有儿女对父母的担忧：
          </div>
          <div class="page-text">
            「比起抗疫的英雄，我更希望您只是妈妈，我和爸爸在家等您！」
          </div>
          <div class="page-text">
            有恋人对彼此的承诺：
          </div>
          <div class="page-text">
            「老姚坚持住，等疫情结束，所有零食都留给你！」
          </div>
          <div class="page-text">
            有夫妻对对方的加油：
          </div>
          <div class="page-text">
            「2020是我们在一起风风雨雨走过的第16个年头，不奢求荣华富贵，只祈求你平安健康！你是家里的天，在前线，一定要注意保护好自己，我和二宝都期待能够早日春暖花开，合家团圆！」
          </div>
          <div class="page-img">
            <img src="../assets/image/page/page2.jpg"/>
          </div>
        </div>
        <!--          第三部分-->
        <div class="page-one">
          <div class="page-text">
            但更多的，是每个关注一线的普通人，对抗疫英雄的感恩之情：
          </div>
          <div class="page-text">
            「你们不顾自己的小家，却要保护国家，我要为你们的爱国行动点赞。同时，你们也要注意自身安全，保护好自己。这是一场没有炮火的战争，这是一个没有硝烟的战争。你们是一个个英勇的战士，在前线“奋勇杀敌”。感谢你们，期待你们的平安归来！中国加油！武汉加油！」
          </div>
          <div class="page-text">
            「你们是生命的守护神，你们用智慧和真诚托起生命的阳光。你们无私，献生命、扶伤痛、含辛茹苦；你们勇敢，抗危机、攻难关、势如破竹；你们忠诚，遵医德、守宗旨、不辱使命。」
          </div>
          <div class="page-text">
            「世界上本没有从天而降的英雄，不过都是那些平凡人在挺身而出，向这些逆行者，跟一线的白衣天使们致敬，期待疫情结束，春暖花开，期待摘下口罩时的也家人面对面拥抱！愿阴霾早日散去，春花早日盛开，我们取下口罩相见。」
          </div>
          <div class="page-text">
            尽管留言的人们千千万万、各有不同，但唯一相同的，是每一字每一句中，大家对于抗疫必胜的坚信——没有一个冬天不可逾越、终有一天会春暖花开、樱花烂漫时，让我们武汉再相会……无数细小而坚韧的声音，饱含着同样的信念，一声声的武汉加油、中国加油，汇聚成一个民族的呐喊：武汉必胜！中国必胜！
          </div>
          <div class="page-img">
            <img src="../assets/image/page/page3.jpg"/>
          </div>
        </div>
        <!--          第四部分-->
        <div class="page-one">
          <div class="page-text">
            每一条留言都真情实感，每一条留言都发自肺腑，每一条留言都感人至深；在这5万条留言之中筛选出精彩留言，无异于一项艰难而又巨大的工程。活动的热烈程度、用户参与的积极程度都是大家始料未及的，行方和极欧团队紧急成立应对小组，各组分工，通宵工作、连夜筛选，常常被感动的热泪盈眶，足以见得只言片语中，字里行间的满腔爱意。
          </div>
          <div class="page-text">
            在中国银行湖北分行的“爱的留言板”活动中，活动平台日均访问3万+，收获留言5万+，用户活跃曲线大幅飙升，拓展新用户8万+。在此活动中，极欧团队为湖北中行提供了强有力的技术保障，面对大量的用户依然能够顺利访问、稳定流畅；以极为专业和严谨的态度响应客户提出的创意想法，不断优化改进、结合社会热点、着眼于用户群体、满足客户需求、丰富具体细节等，将之具化为一次成功的活动策划；同时，此次活动中，用户们以极大的热情积极参与活动，真情实感的留言感动了每一位工作人员。这不仅是一次成功的营销活动，更是国家有难时期，同舟共济克时艰的大爱证明。          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageTwo",
  methods: {
    goHome () {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped lang="less">
.page {
  width: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  .page-container {
    margin-bottom: 60px;
    position: relative;
    margin-top: -150px;
    width: 60%;
    background: #FFFFFF;
    padding:100px 60px 200px 60px;
    box-shadow: 0px 20px 73px 0px rgba(102, 153, 204, 0.2);
    .page-tab {
      padding-top: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      img {
        width: 15px;
        height: 20px;
        margin-right: 10px;
      }
      .page-tab-text {
        cursor: pointer;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
      }
      span {
        color: #2368DD;
        margin-left: 10px;
      }
    }
    .page-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      .page-title {
        text-align: center;
        padding-top: 100px;
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
        opacity: 0.9;
      }
      .page-time {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 45px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        span {
          margin-left: 40px;
        }
        .page-line {
          width: 20%;
          height: 1px;
          background: #000000;
          opacity: 0.2;
        }
      }

    }
    .page-product {
      display: flex;
      flex-direction: column;
      align-items: center;
      .page-feed {
        text-indent:2em;
        border: 1px solid #d4cec4;
        padding: 20px 10px 20px 10px;
        margin-top: 50px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #000000;
        line-height: 26px;
        //opacity: 0.7;
        span{
          color: red;
        }
      }
      .page-icon {
        padding-top:90px ;
        display: flex;
        flex-direction: row;
        align-items: center;
        .page-square {
          width: 10px;
          height: 10px;
          background: #2368DD;
          margin-right: 10px;
        }
        span {
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #000000;
          line-height: 26px;
          opacity: 0.8;
        }
      }

      .page-text {
        text-indent:2em;
        margin-top: 50px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #000000;
        line-height: 26px;
        opacity: 0.7;
      }
      .page-img {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .page-title {
        margin-top: 30px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #000000;
        line-height: 26px;
        opacity: 0.7;
      }
      .page-two-text {
        margin-top: 20px;
        line-height: 50px;
      }
    }
  }
}
@media(max-width: 1200px) {
  .page {
    width: 100%;
  }
}
@media(max-width: 480px) {
  .page {
    .page-container {
      margin-top: -90px;
      padding:50px 60px 100px 60px;
      .page-img {
       img {
         width: 260px;
         height: 173px;
       }
      }
      .page-content {
        .page-title {
          text-align: center;
          padding-top: 50px;
          font-size: 20px;
        }
        .page-time {
          .page-line {
            width: 0;
            height: 0;
          }
        }
      }
    }
  }
}

</style>
